import type React from "react";
import { Dimensions, Platform, StyleSheet, Text, View } from "react-native";
import IconBottomButton from "../../components/IconBottomButton";
import ItemsFlatList from "../../components/ItemsFlatList";
import cColors from "../../styles/componentColors";
import type Task from "../../types/Task";

const { width } = Dimensions.get("window");

interface RecentTasksPageProps {
  navigation: any;
  recentTasks: string[] | null;
  setTaskIds: (taskIds: string[]) => void;
  scrollRef: any;
  modalRect: any;
  showPage1: boolean;
}

const RecentTasksPage: React.FC<RecentTasksPageProps> = ({
  navigation,
  recentTasks,
  setTaskIds,
  scrollRef,
  modalRect,
  showPage1,
}) => {
  return (
    <View style={styles.page}>
      <View style={styles.headerContainer}>
        <Text style={styles.header}>Want to do these today?</Text>
      </View>
      <ItemsFlatList
        listType="SaveForLater"
        navigation={navigation}
        extraSpaceAtEnd
        setTaskIds={setTaskIds}
        filter={
          recentTasks
            ? (task: Task) => recentTasks.includes(task.id)
            : undefined
        }
        paddingInCell
        hideArrowButton
      />

      <IconBottomButton
        side="right"
        singleTap={() => {
          scrollRef.current.scrollTo({
            x: (modalRect ? modalRect.width : width) * (showPage1 ? 2 : 1),
            animation: true,
          });
        }}
        text="➡️"
        isLandscape={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingTop: 0,
    paddingBottom: 12,
    fontSize: 24,
    color: cColors.HEADER_TEXT_COLOR,
  },
  page: {
    backgroundColor: cColors.PAGE_BG_COLOR,
    flex: 1,
    width: Platform.OS === "web" ? "100%" : width,
    paddingTop: 0,
  },
  headerContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 14,
  },
});

export default RecentTasksPage;
